import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';

import { toggleLoginModal as toggleLoginModalAction } from '@department-of-veterans-affairs/platform-site-wide/actions';
import {
  createIsServiceAvailableSelector,
  isLOA1,
  isLOA3,
  selectProfile,
} from '@department-of-veterans-affairs/platform-user/selectors';
import backendServices from '@department-of-veterans-affairs/platform-user/profile/backendServices';
import VerifyAlert from '~/platform/user/authorization/components/VerifyAlert';
import { NoRep } from '../cards';
import { Unauth } from '../alerts';
import { RepresentativeStatusContainer } from '../../containers/RepresentativeStatusContainer';
import { useRepresentativeStatus } from '../../hooks/useRepresentativeStatus';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

export const App = ({
  baseHeader,
  toggleLoginModal,
  isUserLOA1,
  isUserLOA3,
}) => {
  const userHasPOAAccess = useSelector(
    createIsServiceAvailableSelector(backendServices.POWER_OF_ATTORNEY),
  ); // Uses app/policies/power_of_attorney_policy.rb in vets-api

  const DynamicHeader = `h${baseHeader}`;
  const DynamicSubheader = `h${baseHeader + 1}`;
  useGoogleAnalytics({
    userHasPOAAccess,
    isUserLOA1,
    isUserLOA3,
  });

  /*
    When the tool is instantiated in profile, there are some unique
    content/design constraints which are taken care of here
  */

  if (userHasPOAAccess) {
    return (
      <RepresentativeStatusContainer
        DynamicHeader={DynamicHeader}
        DynamicSubheader={DynamicSubheader}
        useRepresentativeStatus={useRepresentativeStatus}
      />
    );
  }

  if (isUserLOA3) {
    return <NoRep DynamicHeader={DynamicHeader} isWidget />;
  }

  if (isUserLOA1) {
    return <VerifyAlert dataTestId="verify-alert" />;
  }

  return (
    <Unauth toggleLoginModal={toggleLoginModal} DynamicHeader={DynamicHeader} />
  );
};

App.propTypes = {
  toggleLoginModal: PropTypes.func.isRequired,
  baseHeader: PropTypes.number,
  hasRepresentative: PropTypes.bool,
  isUserLOA1: PropTypes.bool,
  isUserLOA3: PropTypes.bool,
};

const mapStateToProps = state => ({
  hasRepresentative: state?.user?.login?.hasRepresentative || null,
  isUserLOA1: isLOA1(state),
  isUserLOA3: isLOA3(state),
  signInServiceName: selectProfile(state).signIn?.serviceName,
});

const mapDispatchToProps = dispatch => ({
  toggleLoginModal: open => dispatch(toggleLoginModalAction(open)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
